"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageChoice = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var lodash_1 = require("lodash");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            flexGrow: 1,
            maxWidth: 752,
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
        },
        list: {
            overflowY: 'scroll',
        },
        title: {
            margin: theme.spacing(4, 0, 2),
        },
        firstLine: {
            display: 'flex',
        },
        grow: {
            flexGrow: 1,
        },
    });
});
function LanguageChoice(props) {
    var list = props.list, langTags = props.langTags, scriptName = props.scriptName, secondary = props.secondary, t = props.t, choose = props.choose;
    var classes = useStyles();
    var dense = react_1.default.useState(true)[0];
    var _a = react_1.default.useState(window.innerHeight), height = _a[0], setHeight = _a[1];
    var handleChoose = function (tag) { return function () {
        choose(tag);
    }; };
    var handleKeydown = function (tag) { return function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            choose(tag);
        }
    }; };
    react_1.default.useEffect(function () {
        var handleResize = lodash_1.debounce(function () { return setHeight(window.innerHeight); }, 100);
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var scriptDetail = function (tag) {
        var tagParts = tag.tag.split('-');
        return tagParts.length > 1 && tagParts[1].length === 4
            ? t.inScript.replace('$1', scriptName[tagParts[1]])
            : '';
    };
    var detail = function (tag) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { component: 'span' }, t.languageOf
                .replace('$1', tag.regionname ? tag.regionname : '')
                .replace('$2', scriptDetail(tag))),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { component: 'span' }, tag.names ? tag.names.join(', ') : '')));
    };
    var langElems = function (refList, refTags) {
        return refList.map(function (r, i) {
            var tag = refTags[r];
            return (react_1.default.createElement(core_1.ListItem, { key: tag.tag + " " + i, button: true, onClick: handleChoose(tag), onKeyDown: handleKeydown(tag) },
                react_1.default.createElement(core_1.ListItemText, { primary: react_1.default.createElement("div", { className: classes.firstLine },
                        react_1.default.createElement(core_1.Typography, null, tag.name),
                        react_1.default.createElement("div", { className: classes.grow }, '\u00A0'),
                        react_1.default.createElement(core_1.Typography, null, tag.tag)), secondary: secondary ? detail(tag) : null })));
        });
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.paper },
            react_1.default.createElement(core_1.List, { dense: dense, className: classes.list, style: { maxHeight: Math.max(height - 450, 200) } }, langElems(list, langTags)))));
}
exports.LanguageChoice = LanguageChoice;
exports.default = LanguageChoice;
